import AdminLayout from "../../../components/admin/layout/AdminLayout";
import { useLocation } from "react-router-dom";
import SurveyorSingleView from "../../../components/common/surveyor/SurveyorSingleView";
import useAuthStore from "../../../store/authStore";
import ManagerSidebar from "../../../components/managerLiveDashboard/sidebar/ManagerSidebar";

function SurveyorSingleViewPage() {
  const { userType } = useAuthStore();
  const location = useLocation();
  const id = location.state || {};

  return (
    <AdminLayout
      sidebarComponent={userType === 'admin' ? undefined : ManagerSidebar}
    >
      <SurveyorSingleView id={id} />
    </AdminLayout>
  );
}

export default SurveyorSingleViewPage;
